import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import BackToTop from './components/BackToTop/BackToTop';
import Home from './pages/Home';
import WarehouseManagement from './pages/mycase/WarehouseManagement';
import GraduateIndustryProject from './pages/mycase/GraduateIndustryProject';
import QuantitativeTrading from './pages/mycase/QuantitativeTrading';
import './styles/global.css';

const { Content } = Layout;

// 滚动到顶部组件
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// 条件渲染BackToTop组件
function ConditionalBackToTop() {
  // BackToTop 组件现在在所有页面都显示
  return <BackToTop />;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout className="app-layout">
        {/* Header section */}
        <Header />

        {/* Content section */}
        <Content className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/warehouse-management" element={<WarehouseManagement />} />
            <Route path="/graduate-industry-project" element={<GraduateIndustryProject />} />
            <Route path="/quantitative-trading" element={<QuantitativeTrading />} />
          </Routes>
        </Content>

        {/* Footer section */}
        <Footer />

        {/* Conditional Back to Top Button */}
        <ConditionalBackToTop />
      </Layout>
    </Router>
  );
}

export default App;